import { useEffect, useState } from 'react';
import './SellerHome.css';

const SellerHome = () => {
  const [language, setLanguage] = useState('en');
  const [isLoading, setIsLoading] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  // Scroll effect for parallax
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const content = {
    en: {
      badge: "Verified Publisher",
      title: "Alvin Ahmad Dev",
      subtitle: "Crafting exceptional mobile experiences for Samsung Galaxy Store",
      getStarted: "Visit Galaxy Store",
      learnMore: "Documentation",
      brandTitle: "Who We Are",
      brandDesc: "We specialize in developing innovative productivity and lifestyle applications that empower users across all age groups. Our mission is to create practical, efficient tools that seamlessly integrate with Samsung devices, delivering exceptional user experiences to a global audience.",
      missionTitle: "Our Mission",
      missionDesc: "Alvin Ahmad Dev is a forward-thinking technology company dedicated to creating high quality mobile applications. Founded with the vision to empower users worldwide, we focus on delivering innovative solutions that combine functionality, reliability, and user-centric design specifically for Samsung Galaxy ecosystem.",
      focusAreas: "Focus Areas",
      focusDesc: "We concentrate on two core sectors that directly impact daily life",
      productivityTitle: "Productivity Apps",
      productivityDesc: "Tools that enhance workflow efficiency and personal organization",
      lifestyleTitle: "Lifestyle Apps",
      lifestyleDesc: "Solutions that improve daily living and personal well-being",
      valuesTitle: "Core Values",
      innovation: "Innovation",
      innovationDesc: "Cutting-edge solutions for modern challenges",
      quality: "Quality",
      qualityDesc: "Excellence in every line of code we write",
      accessibility: "Accessibility",
      accessibilityDesc: "Apps designed for users of all abilities",
      guidelinesTitle: "Publisher Guidelines",
      guidelinesDesc: "Essential requirements for Galaxy Store success",
      completionTitle: "Profile Completion",
      completionDesc: "Ensure comprehensive company information for optimal store visibility and user trust.",
      recommendationTitle: "Key Recommendations",
      rec1: "Provide detailed company background and mission",
      rec2: "Include comprehensive contact and support information",
      rec3: "Maintain consistent branding across all materials",
      rec4: "Regular updates to reflect company growth",
      warningText: "Incomplete profiles receive generic store presentation, significantly reducing discoverability and user confidence.",
      statsTitle: "Our Performance",
      statsSubtitle: "Key metrics showcasing our development success",
      totalApps: "Total Apps",
      avgRating: "Average Rating",
      totalDownloads: "Total Downloads",
      activeUsers: "Active Users",
      policiesTitle: "Policies & Guidelines",
      policiesSubtitle: "Essential legal and privacy information",
      tosTitle: "Terms of Service",
      tosDesc: "Comprehensive terms and conditions governing the use of our applications and services, outlining user rights, responsibilities, and platform guidelines.",
      privacyTitle: "Privacy Policy",
      privacyDesc: "Detailed explanation of how we collect, use, store, and protect user data in compliance with global privacy regulations including GDPR and applicable data protection laws.",
      contactTitle: "Get in Touch",
      contactSubtitle: "Connect with us for support and collaboration",
      emailLabel: "Email",
      instagramLabel: "Instagram",
    },
    id: {
      badge: "Penerbit Terverifikasi",
      title: "Alvin Ahmad Dev",
      subtitle: "Menciptakan pengalaman mobile luar biasa untuk Samsung Galaxy Store",
      getStarted: "Kunjungi Galaxy Store",
      learnMore: "Dokumentasi",
      brandTitle: "Siapa Kami",
      brandDesc: "Kami mengkhususkan diri dalam mengembangkan aplikasi produktivitas dan gaya hidup inovatif yang memberdayakan pengguna dari segala usia. Misi kami adalah menciptakan alat praktis dan efisien yang terintegrasi mulus dengan perangkat Samsung, memberikan pengalaman pengguna luar biasa kepada audiens global.",
      missionTitle: "Misi Kami",
      missionDesc: "Alvin Ahmad Dev adalah perusahaan teknologi berpikiran maju yang didedikasikan untuk menciptakan aplikasi mobile berkualitas tinggi. Didirikan dengan visi memberdayakan pengguna di seluruh dunia, kami fokus memberikan solusi inovatif yang menggabungkan fungsionalitas, keandalan, dan desain berpusat pengguna khusus untuk ekosistem Samsung Galaxy.",
      focusAreas: "Area Fokus",
      focusDesc: "Kami berkonsentrasi pada dua sektor inti yang berdampak langsung pada kehidupan sehari-hari",
      productivityTitle: "Aplikasi Produktivitas",
      productivityDesc: "Alat yang meningkatkan efisiensi alur kerja dan organisasi personal",
      lifestyleTitle: "Aplikasi Gaya Hidup",
      lifestyleDesc: "Solusi yang meningkatkan kehidupan sehari-hari dan kesejahteraan personal",
      valuesTitle: "Nilai Inti",
      innovation: "Inovasi",
      innovationDesc: "Solusi mutakhir untuk tantangan modern",
      quality: "Kualitas",
      qualityDesc: "Keunggulan dalam setiap baris kode yang kami tulis",
      accessibility: "Aksesibilitas",
      accessibilityDesc: "Aplikasi dirancang untuk pengguna dengan segala kemampuan",
      guidelinesTitle: "Pedoman Penerbit",
      guidelinesDesc: "Persyaratan penting untuk kesuksesan Galaxy Store",
      completionTitle: "Kelengkapan Profil",
      completionDesc: "Pastikan informasi perusahaan komprehensif untuk visibilitas toko optimal dan kepercayaan pengguna.",
      recommendationTitle: "Rekomendasi Utama",
      rec1: "Berikan latar belakang dan misi perusahaan yang detail",
      rec2: "Sertakan informasi kontak dan dukungan yang komprehensif",
      rec3: "Pertahankan branding yang konsisten di semua materi",
      rec4: "Update berkala untuk mencerminkan pertumbuhan perusahaan",
      warningText: "Profil tidak lengkap mendapat presentasi toko generik, secara signifikan mengurangi kemudahan ditemukan dan kepercayaan pengguna.",
      statsTitle: "Performa Kami",
      statsSubtitle: "Metrik utama yang menunjukkan kesuksesan pengembangan kami",
      totalApps: "Total Aplikasi",
      avgRating: "Rating Rata-rata",
      totalDownloads: "Total Unduhan",
      activeUsers: "Pengguna Aktif",
      policiesTitle: "Kebijakan & Pedoman",
      policiesSubtitle: "Informasi hukum dan privasi yang penting",
      tosTitle: "Ketentuan Layanan",
      tosDesc: "Syarat dan ketentuan komprehensif yang mengatur penggunaan aplikasi dan layanan kami, menguraikan hak pengguna, tanggung jawab, dan pedoman platform.",
      privacyTitle: "Kebijakan Privasi",
      privacyDesc: "Penjelasan detail tentang bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi data pengguna sesuai dengan regulasi privasi global termasuk GDPR dan undang-undang perlindungan data yang berlaku.",
      contactTitle: "Hubungi Kami",
      contactSubtitle: "Terhubung dengan kami untuk dukungan dan kolaborasi",
      emailLabel: "Email",
      instagramLabel: "Instagram",
    }
  };

  const currentContent = content[language];

  const handleGetStarted = async () => {
    setIsLoading(true);
    // Simulate API call for better UX
    setTimeout(() => {
      window.open('https://galaxystore.samsung.com/apps', '_blank');
      setIsLoading(false);
    }, 800);
  };

  const handleLearnMore = () => {
    window.open('/seller/help', '_blank');
  };

  return (
    <div className="seller-home">
      {/* Enhanced Language Selector */}
      <div className="language-selector">
        <div className="lang-wrapper">
          <button
            className={`lang-btn ${language === 'en' ? 'active' : ''}`}
            onClick={() => setLanguage('en')}
            aria-label="Switch to English"
          >
            🇺🇸 EN
          </button>
          <button
            className={`lang-btn ${language === 'id' ? 'active' : ''}`}
            onClick={() => setLanguage('id')}
            aria-label="Beralih ke Bahasa Indonesia"
          >
            🇮🇩 ID
          </button>
        </div>
      </div>

      {/* Hero Section with Enhanced Visual Hierarchy */}
      <section className="hero-section" style={{ transform: `translateY(${scrollY * 0.1}px)` }}>
        <div className="hero-background">
          <div className="gradient-overlay"></div>
          <div className="floating-elements">
            <div className="floating-element element-1"></div>
            <div className="floating-element element-2"></div>
            <div className="floating-element element-3"></div>
            <div className="floating-element element-4"></div>
          </div>
        </div>

        <div className="container">
          <header className="hero-content">
            <div className="status-badge" data-aos="fade-down" data-aos-delay="100">
              <span className="badge-icon">✨</span>
              <span>{currentContent.badge}</span>
            </div>

            <h1 className="hero-title" data-aos="fade-up" data-aos-delay="200">
              <span className="company-name">Alvin Ahmad Dev</span>
            </h1>

            <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="300">
              Crafting exceptional mobile experiences for Samsung Galaxy Store
            </p>

            <div className="cta-group" data-aos="fade-up" data-aos-delay="400">
              <button
                className={`btn-primary ${isLoading ? 'loading' : ''}`}
                onClick={handleGetStarted}
                disabled={isLoading}
                aria-label={currentContent.getStarted}
              >
                {isLoading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Loading...
                  </>
                ) : (
                  <>
                    <span className="btn-icon">🚀</span>
                    {currentContent.getStarted}
                  </>
                )}
              </button>

              <button
                className="btn-secondary"
                onClick={handleLearnMore}
                aria-label={currentContent.learnMore}
              >
                <span className="btn-icon">📚</span>
                {currentContent.learnMore}
              </button>
            </div>
          </header>
        </div>
      </section>

      <div className="container">
        {/* Brand Introduction with Improved Information Architecture */}
        <section className="brand-section" data-aos="fade-up">
          <div className="section-header">
            <h2 className="section-title">{currentContent.brandTitle}</h2>
          </div>

          <div className="brand-card">
            <div className="card-icon">
              <div className="icon-wrapper">
                <span>🎯</span>
              </div>
            </div>
            <div className="card-content">
              <p className="brand-description">{currentContent.brandDesc}</p>
              <div className="feature-tags">
                <span className="feature-tag productivity">Productivity</span>
                <span className="feature-tag lifestyle">Lifestyle</span>
                <span className="feature-tag integration">Samsung Integration</span>
                <span className="feature-tag global">Global Reach</span>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section with Enhanced Visual Contrast */}
        <section className="mission-section" data-aos="fade-up" data-aos-delay="100">
          <div className="section-header">
            <h2 className="section-title">{currentContent.missionTitle}</h2>
          </div>

          <div className="mission-card">
            <div className="card-icon">
              <div className="icon-wrapper mission">
                <img src="/image.png" alt="Alvin Ahmad Dev" className="mission-image" />
              </div>
            </div>
            <div className="card-content">
              <p className="mission-description">{currentContent.missionDesc}</p>
            </div>
          </div>
        </section>

        {/* Focus Areas with Gestalt Principles */}
        <section className="focus-section" data-aos="fade-up" data-aos-delay="200">
          <div className="section-header">
            <h2 className="section-title">{currentContent.focusAreas}</h2>
            <p className="section-subtitle">{currentContent.focusDesc}</p>
          </div>

          <div className="focus-grid">
            <div className="focus-card productivity-card" data-aos="fade-right" data-aos-delay="300">
              <div className="focus-icon">
                <span>⚡</span>
              </div>
              <h3 className="focus-title">{currentContent.productivityTitle}</h3>
              <p className="focus-description">{currentContent.productivityDesc}</p>
              <div className="card-accent productivity-accent"></div>
            </div>

            <div className="focus-card lifestyle-card" data-aos="fade-left" data-aos-delay="400">
              <div className="focus-icon">
                <span>🌟</span>
              </div>
              <h3 className="focus-title">{currentContent.lifestyleTitle}</h3>
              <p className="focus-description">{currentContent.lifestyleDesc}</p>
              <div className="card-accent lifestyle-accent"></div>
            </div>
          </div>
        </section>

        {/* Core Values with Enhanced Cognitive Load Management */}
        <section className="values-section" data-aos="fade-up" data-aos-delay="300">
          <div className="section-header">
            <h2 className="section-title">{currentContent.valuesTitle}</h2>
          </div>

          <div className="values-grid">
            <div className="value-card" data-aos="zoom-in" data-aos-delay="400">
              <div className="value-icon innovation">
                <span>💡</span>
              </div>
              <h3 className="value-title">{currentContent.innovation}</h3>
              <p className="value-description">{currentContent.innovationDesc}</p>
            </div>

            <div className="value-card" data-aos="zoom-in" data-aos-delay="500">
              <div className="value-icon quality">
                <span>⭐</span>
              </div>
              <h3 className="value-title">{currentContent.quality}</h3>
              <p className="value-description">{currentContent.qualityDesc}</p>
            </div>

            <div className="value-card" data-aos="zoom-in" data-aos-delay="600">
              <div className="value-icon accessibility">
                <span>🤝</span>
              </div>
              <h3 className="value-title">{currentContent.accessibility}</h3>
              <p className="value-description">{currentContent.accessibilityDesc}</p>
            </div>
          </div>
        </section>

        {/* Statistics Section */}
        <section className="stats-section" data-aos="fade-up">
          <div className="section-header">
            <h2 className="section-title">{currentContent.statsTitle}</h2>
            <p className="section-subtitle">{currentContent.statsSubtitle}</p>
          </div>
          
          <div className="stats-grid">
            <div className="stat-card" data-aos="zoom-in" data-aos-delay="100">
              <div className="stat-icon">📱</div>
              <h3 className="stat-number">12+</h3>
              <p className="stat-label">{currentContent.totalApps}</p>
              <div className="stat-trend">
                <span className="trend-icon">📈</span>
                <span className="trend-text">+3 this year</span>
              </div>
            </div>
            
            <div className="stat-card" data-aos="zoom-in" data-aos-delay="200">
              <div className="stat-icon">⭐</div>
              <h3 className="stat-number">4.7</h3>
              <p className="stat-label">{currentContent.avgRating}</p>
              <div className="stat-trend">
                <span className="trend-icon">🔥</span>
                <span className="trend-text">Excellent</span>
              </div>
            </div>
            
            <div className="stat-card" data-aos="zoom-in" data-aos-delay="300">
              <div className="stat-icon">📥</div>
              <h3 className="stat-number">250K+</h3>
              <p className="stat-label">{currentContent.totalDownloads}</p>
              <div className="stat-trend">
                <span className="trend-icon">🚀</span>
                <span className="trend-text">Growing</span>
              </div>
            </div>
            
          </div>
        </section>

        {/* Policies Section */}
        <section className="policies-section" data-aos="fade-up" data-aos-delay="500">
          <div className="section-header">
            <h2 className="section-title">{currentContent.policiesTitle}</h2>
            <p className="section-subtitle">{currentContent.policiesSubtitle}</p>
          </div>
          
          <div className="policies-grid">
            <div className="policy-card" data-aos="fade-right" data-aos-delay="600">
              <div className="policy-icon">
                <span>📋</span>
              </div>
              <h3 className="policy-title">{currentContent.tosTitle}</h3>
              <p className="policy-description">{currentContent.tosDesc}</p>
              <div className="policy-actions">
                <button className="policy-btn primary">
                  <span className="btn-icon">📖</span>
                  {language === 'en' ? 'Read Terms' : 'Baca Ketentuan'}
                </button>
              </div>
            </div>
            
            <div className="policy-card" data-aos="fade-left" data-aos-delay="700">
              <div className="policy-icon">
                <span>🔒</span>
              </div>
              <h3 className="policy-title">{currentContent.privacyTitle}</h3>
              <p className="policy-description">{currentContent.privacyDesc}</p>
              <div className="policy-actions">
                <button className="policy-btn primary">
                  <span className="btn-icon">🛡️</span>
                  {language === 'en' ? 'View Policy' : 'Lihat Kebijakan'}
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section" data-aos="fade-up" data-aos-delay="600">
          <div className="section-header">
            <h2 className="section-title">{currentContent.contactTitle}</h2>
            <p className="section-subtitle">{currentContent.contactSubtitle}</p>
          </div>

          <div className="contact-grid">
            <div className="contact-card email-card" data-aos="fade-up" data-aos-delay="700">
              <div className="contact-icon">
                <span>📧</span>
              </div>
              <h3 className="contact-title">{currentContent.emailLabel}</h3>
              <a href="mailto:qalvinahmad@gmail.com" className="contact-link">
                qalvinahmad@gmail.com
              </a>
              <p className="contact-description">
                {language === 'en' ? 'For business inquiries and support' : 'Untuk pertanyaan bisnis dan dukungan'}
              </p>
            </div>

            <div className="contact-card social-card" data-aos="fade-up" data-aos-delay="800">
              <div className="contact-icon">
                <span>📱</span>
              </div>
              <h3 className="contact-title">{currentContent.instagramLabel}</h3>
              <a href="https://instagram.com/qalvinahmad" target="_blank" rel="noopener noreferrer" className="contact-link">
                @qalvinahmad
              </a>
              <p className="contact-description">
                {language === 'en' ? 'Follow for updates and behind-the-scenes' : 'Ikuti untuk update dan konten di balik layar'}
              </p>
            </div>
          </div>
        </section>



      </div>
    </div>
  );
};

export default SellerHome;
